import { IQueryOptions, IExecutionOptions } from '../models/query';
import { ConditionalHelper } from '../helpers/ConditionalHelper';
import { IEntity } from '../models/api/search';
import { Query } from './Query';
import { TranslationHelper } from '../helpers/TranslationHelper';
import { IQueryOptionsEntityBase } from '../models/query/options/IQueryOptionsEntityBase';
import { BaseQuery } from './BaseQuery';

export const MAX_CALL_STACK_LEVEL: number = 50;

export abstract class BaseEntityQuery<TChildOptions extends IQueryOptionsEntityBase> extends BaseQuery<TChildOptions> {
	constructor(queryOptions: IQueryOptions, translationHelper?: TranslationHelper) {
		super(queryOptions, translationHelper);
	}
	getSubCollection(executionOptions: IExecutionOptions): any[] {
		const { queryOptionsType } = this.queryOptions;
		const entity = this.getEntity(executionOptions);
		if (entity && entity[queryOptionsType]) {
			return entity[queryOptionsType];
		}
		return [];
	}
	getEntity(executionOptions: IExecutionOptions): IEntity | undefined {
		const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
		const context = Query.getContext(executionOptions, this.queryOptions);
		if (context) {
			const { entityByType } = context;
			const {
				entityType,
				entityConditional,
			} = this.options;
			const entity = entityByType && entityType && entityByType[entityType];
			if (entity && (!entityConditional || conditionalHelper.matches(entity, entityConditional, executionOptions))) {
				return entity as IEntity;
			}
		}
		return;
	}

	getEntities(executionOptions: IExecutionOptions): IEntity[] | undefined {
		const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
		const context = Query.getContext(executionOptions, this.queryOptions);
		if (context) {
			const { entities } = context;
			const {
				queryId,
			} = this.queryOptions;
			const {
				entityConditional,
			} = this.options;
			const entitiesContext = (entities && queryId && entities[queryId]);
			if (entitiesContext) {
				return entitiesContext.values.filter(entity => (!entityConditional || conditionalHelper.matches(entity, entityConditional, executionOptions))) as IEntity[];
			}
		}
		return;
	}

}